/*
  utils/Api

  Contains request configuration and execution methods
 */

/* eslint-disable */

// Detect if we're in react-snap pre-rendering
const isPrerendering = navigator.userAgent === 'ReactSnap';

export const HOST = (host => {
  // If pre-rendering, use production API
  if (isPrerendering || typeof window === 'undefined') {
    return 'https://api.thedogsharecollective.com';
  }

  if (host === 'localhost:3000') {
    // return 'http://dog-api.test';
    return 'https://api.thedogsharecollective.com';
  }
  if (host === 'dogshare.co:3000') {
    return 'https://api.dogshare.io';
  }
  if (host === 'stage.thedogsharecollective.com') {
    return 'https://stage-api.thedogsharecollective.com';
  }
  if (host === 'dogshare.io') {
    return 'https://api.dogshare.io';
  }
  if (host === 'www.dogshare.io') {
    return 'https://api.dogshare.io';
  }
  if (host === 'www.thedogsharecollective.com') {
    return 'https://api.thedogsharecollective.com';
  }
  return 'https://api.thedogsharecollective.com';
})(typeof window !== 'undefined' ? window.location.host : 'prerender');

export const IS_MESSAGING_ENABLED = (host => {
  // If pre-rendering, return true
  if (isPrerendering || typeof window === 'undefined') {
    return true;
  }

  if (host === 'localhost:3000') {
    return true;
  }
  if (host === 'dogshare.co:3000') {
    return true;
  }
  if (host === 'stage.thedogsharecollective.com') {
    return true;
  }
  if (host === 'dogshare.io') {
    return true;
  }
  if (host === 'www.dogshare.io') {
    return true;
  }
  if (host === 'www.thedogsharecollective.com') {
    return true;
  }
  return true;
})(typeof window !== 'undefined' ? window.location.host : 'prerender');

export const ASSET_BASE_URL = HOST;
export const API_HOST = `${HOST}/api/v1`;
const CONTENT_AS_FORMDATA = false;
const REQUEST_TIMEOUT = 120000;

export const TOP_LEVEL_DOMAIN = API_HOST.replace('/api/v1', '');
export const AUTH_HEADER = 'X-Authorization';

/*
  Basic usage:

    request('auth/token', 'POST', {
      email: 'oliver.shaw@littlegiant.co.nz',
      password: 'password'
    });
*/
export const request = (
  endpoint,
  method = 'GET',
  body = {},
  headers = null,
  allow_body_mutation = true,
) => {
  let API_ADDRESS = API_HOST;

  // Merge default headers with request headers
  let requestHeaders = Object.assign({}, headers || {});

  // Remove any headers with undefined values
  Object.keys(requestHeaders).forEach(key => {
    if (requestHeaders[key] === undefined || requestHeaders[key] === null) {
      console.warn(`Removing header '${key}' with undefined/null value`);
      delete requestHeaders[key];
    }
  });

  if (method == 'GET' && body !== null && Object.keys(body).length > 0) {
    endpoint = `${endpoint}?${encodeQueryData(body)}`;
    console.log('GET request with query params, final endpoint:', endpoint);
  } else if (allow_body_mutation && method !== 'GET') {
    // Convert body to acceptable type
    if (typeof body === 'object' && CONTENT_AS_FORMDATA && method !== 'PATCH') {
      // Convert object to FormData
      const formData = new FormData();
      for (const key in body) {
        formData.append(key, body[key]);
      }

      body = formData;
    } else if (CONTENT_AS_FORMDATA && method === 'PATCH') {
      requestHeaders = Object.assign(
        {},
        {
          'Content-Type': 'x-www-form-urlencoded',
        },
        requestHeaders,
      );

      body = encodeQueryData(body);
    } else if (typeof body === 'object' && !CONTENT_AS_FORMDATA) {
      // Convert object to a JSON string
      body = JSON.stringify(body);
      // Set Content-Type header for JSON
      if (!requestHeaders['Content-Type']) {
        requestHeaders['Content-Type'] = 'application/json';
      }
    }
  }

  console.log('REQUEST_DISPATCHED', endpoint);
  const fullUrl = `${API_ADDRESS}/${endpoint}`;
  console.log('Full URL for fetch:', fullUrl);
  console.log('Request headers:', requestHeaders);
  console.log('Request method:', method);
  console.log('Request body:', method !== 'GET' ? body : 'N/A for GET');

  // Execute request - returns a Promise so we can chain subsequent actions to dispatch to the store
  return new Promise((resolve, reject) => {
    timeoutPromise(
      REQUEST_TIMEOUT,
      fetch(fullUrl, {
        method: method,
        credentials: 'same-origin', // This is set on request
        headers: requestHeaders,
        body: method != 'GET' ? body : undefined,
      }),
    )
      .then(
        response => {
          console.log('API_RESPONSE', endpoint, response.status);

          return response.json().then(
            responseJSON =>
              // Transform the response into its JSON representation
              ({
                status: response.status,
                data: responseJSON,
              }),
            error => {
              if (response.status >= 200 && response.status < 300) {
                // No body, but still a successful request. Return success code
                return {
                  status: response.status,
                  data: null,
                };
              }
            },
          );
        },
        err => {
          console.error('Fetch failed for URL:', fullUrl);
          console.error('Error details:', err);
          console.error('Error message:', err.message);
          console.error('Error stack:', err.stack);
          reject(err);
        },
      )
      .then(
        data => {
          if (data && data.status > 200) {
            reject(data);
          } else {
            resolve(data);
          }
        },
        error => {
          console.log('API_ERROR', endpoint, headers, body);
          reject(error);
        },
      );
  });
};

/*
  Assist creation of GET queries
 */
function encodeQueryData(data) {
  const ret = [];
  for (const d in data) {
    ret.push(`${encodeURIComponent(d)}=${encodeURIComponent(data[d])}`);
  }

  return ret.join('&');
}

/*
  Fetch wrapper to handle timeouts
 */
function timeoutPromise(ms, promise) {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject();
    }, ms);
    promise.then(
      res => {
        clearTimeout(timeoutId);
        resolve(res);
      },
      err => {
        clearTimeout(timeoutId);
        reject(err);
      },
    );
  });
}



// WEBPACK FOOTER //
// ./src/utils/Api.js